<template>
  <v-card outlined class="rounded-lg">
    <v-img :src="'/static/calendarEventImages/img_schankverlust_1x.jpg'" height="100px">
      <v-card-title class="white--text">Schankverlust {{ $filters.date(monat, "MM.YY") }}</v-card-title>
    </v-img>
    <v-card-text class="pa-0">
      <v-simple-table dense fixed-header>
        <tbody>
          <tr>
            <td>Striche Soll (Theorie)</td>
            <td class="text-right">{{ statistik.gesamtStricheTheorie }}</td>
          </tr>
          <tr>
            <td>Striche Ist (Praxis)</td>
            <td class="text-right">{{ statistik.gesamtStrichePraxis }}</td>
          </tr>
          <tr>
            <td>Striche Differenz</td>
            <td class="text-right">
              {{ statistik.gesamtStricheTheorie - statistik.gesamtStrichePraxis }} ({{ statistik.schankverlust }}%)
            </td>
          </tr>
          <tr>
            <td>10% Schankverlust</td>
            <td class="text-right">{{ (statistik.gesamtStricheTheorie * 0.1).toFixed(0) }}</td>
          </tr>
          <tr>
            <td>fehlende Striche</td>
            <td class="text-right">
              {{
                statistik.gesamtStricheTheorie -
                statistik.gesamtStrichePraxis -
                (statistik.gesamtStricheTheorie * 0.1).toFixed(0)
              }}
            </td>
          </tr>
          <tr class="amber lighten-3">
            <td>Fehlbetrag Schankverlust</td>
            <td class="text-right">
              {{
                ((statistik.gesamtStricheTheorie - statistik.gesamtStrichePraxis) * statistik.durchschnittsStrichPreis)
                  | money
              }}
            </td>
          </tr>
          <tr class="amber lighten-3">
            <td>Fehlbetrag Schankverlust (-10%)</td>
            <td class="text-right">
              {{
                ((statistik.gesamtStricheTheorie -
                  statistik.gesamtStricheTheorie * 0.1 -
                  statistik.gesamtStrichePraxis) *
                  statistik.durchschnittsStrichPreis)
                  | money
              }}
            </td>
          </tr>
          <tr>
            <td>Oe-Kisten</td>
            <td class="text-right">{{ statistik.oettingerKisten }}</td>
          </tr>
          <tr>
            <td>Couleurstriche</td>
            <td class="text-right">{{ statistik.couleurstricheAnzahl }}</td>
          </tr>
          <tr class="amber lighten-3">
            <td>Kosten Oettinger und Couleurbier</td>
            <td class="text-right">
              {{
                (parseFloat(statistik.oettingerKistenPreis) +
                  statistik.couleurstricheAnzahl * statistik.durchschnittsStrichPreis)
                  | money
              }}
            </td>
          </tr>
          <tr class="amber lighten-1 font-weight-bold">
            <td>Summe</td>
            <td class="text-right">
              {{
                (statistik.oettingerKisten * 6.78 +
                  statistik.couleurstricheAnzahl * statistik.durchschnittsStrichPreis +
                  statistik.gesamtStricheTheorie -
                  statistik.gesamtStrichePraxis -
                  (statistik.gesamtStricheTheorie * 0.1).toFixed(0) * statistik.durchschnittsStrichPreis)
                  | money
              }}
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>

<script>
  export default {
    data() {
      return {
        monat: new Date(new Date().getFullYear(), new Date().getMonth()).toISOString().substr(0, 7),
      };
    },
    computed: {
      statistik() {
        if (this.$store.state.statistiken.statistiken.length === 0) {
          this.$store.dispatch("statistiken/loadStatistiken");
        }
        return this.$store.state.statistiken.statistiken.find((statistik) => statistik.monat === this.monat);
      },
    },
  };
</script>



// WEBPACK FOOTER //
// schankverlust.vue?3629bcc2